import { render, staticRenderFns } from "./ServiceTerminationNotice.vue?vue&type=template&id=3e06737a&scoped=true"
import script from "./ServiceTerminationNotice.vue?vue&type=script&lang=js"
export * from "./ServiceTerminationNotice.vue?vue&type=script&lang=js"
import style0 from "./ServiceTerminationNotice.vue?vue&type=style&index=0&id=3e06737a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06737a",
  null
  
)

export default component.exports